<template>
  <div
    class="wallet-train color-3 font-weight-light"
    :style="`
      ${shadow ? 'box-shadow: 0 -5px 5px -5px #000000;' : ''}
      ${no_margin_top ? 'margin-top: 3px' : ''}
      ${getUseOnSite ? 'min-height: 98px;' : 'min-height: 40px;'}
    `"
  >
    <div class="wallet-train-name-slot">
      <slot
        name="name"
        :wallet_settings="wallet_settings"
        />
    </div>
    <slot
      name="content"
      :wallet_settings="wallet_settings"
      :step_cards="step_cards"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: [
    'train',
    'shadow',
    'wallet_settings',
    'no_margin_top',
    'step_cards'
  ],

  data: () => ({

  }),

  computed: {
    ...mapGetters('View',[
      'getUseOnSite'
    ]),
  },
}
</script>
<style>
.wallet-train {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  user-select: none;
  z-index: 2;
  padding: 3px 10px 0px 10px;
  margin-top: 15px;
  color: var(--v-primary-base);
}
.wallet-train-name-slot {
  margin-bottom: 17px;
  margin-top: 17px;
}
</style>
